import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedEnterprise: null,
};

const enterpriseSlice = createSlice({
  name: "enterprise",
  initialState,
  reducers: {
    setEnterprise: (state, action) => {
      state.selectedEnterprise = action.payload;
    },
  },
});

export const {
  setEnterprise,
} = enterpriseSlice.actions;

export default enterpriseSlice.reducer;
